/* eslint-disable import/prefer-default-export */
// CONSTANTES DE AYUDA
export const instructions = () => {
  // FOR SIDEBARS
  const insAspiranteslist = {
    seccion: { nombre: 'Lista de Aspirantes', desc: 'Hola, se muestra el pre-registros de todos los aspirantes a una especialidad o diplomado y su proceso.' },
    guiaB: [
      {
        id: 0, icon: 'ActivityIcon', color: 'dark', titulo: 'Sin documentación por revisar', desc: 'Cuando el aspirante no tiene documentación por revisar, puede representar que esta al corriente o no tiene pendientes por revisar.', tag: 'admin',
      },
      {
        id: 1, icon: 'FileTextIcon', color: 'warning', titulo: 'Documentación Pendiente', desc: 'El aspirante tiene documentación por revisar.', tag: 'admin',
      },
      {
        id: 2, icon: 'Link2Icon', color: 'info', titulo: 'Completar Registro', desc: 'Para dar paso a la documentación es importante que el aspirante finalice su registro.', tag: 'aspirante',
      },
      {
        id: 3, icon: 'LinkIcon', color: 'danger', titulo: 'Link de Documentación', desc: 'Link para subir la documentación necesaria de un aspirante', tag: 'aspirante',
      },
      {
        id: 4, icon: 'MailIcon', color: 'secondary', titulo: 'Reenviar correo', desc: 'Puedes reenviar el correo de datos bancarios tantas veces como lo necesites.', tag: 'admin',
      },
      {
        id: 5, icon: 'ShoppingBagIcon', color: 'primary', titulo: 'Orden de Inscripción', desc: 'Muestra la orden de pago activa para el aspirante, puede ser cancelada .', tag: 'admin',
      },
      {
        id: 6, icon: 'EditIcon', color: 'success', titulo: 'Generar Referencia', desc: 'Para habilitar la matriculación y la liberación de cursos, es necesario definir los datos bancarios.', tag: 'admin',
      },
      {
        id: 7, icon: 'SlashIcon', color: 'warning', titulo: 'Cancelar Registro', desc: 'Opción para cancelar el proceso de un aspirante con su debida justificación.', tag: 'admin',
      },
      {
        id: 8, icon: 'ArrowUpCircleIcon', color: 'success', titulo: 'Finalizar Proceso', desc: 'A los alumnos que cursan por segunda vez una especialidad se les habilitará esta opción para finalizar su proceso', tag: 'admin',
      },
    ],
    procesos: [
      { titulo: 'Nivel - Paso 1', desc: 'El aspirante tiene incompleto su registro y debe completar sus datos personales.' },
      { titulo: 'Nivel - Paso 2', desc: 'Los documentos fueron completados y esta en espera de una orden de pago [ referencia ].' },
      { titulo: 'Nivel - Paso 3', desc: 'El aspirante cuenta con una orden de pago y podra ser vista desde aspirantes o desde ordenes. ' },
      { titulo: 'Nivel - Paso 4', desc: 'El aspirante ya pago y cuenta con matricula, solo esta en espera de crear su cuenta en campus [ CREDENCIALES ]. ' },
      { titulo: 'Paso 5 - Cuenta', desc: 'El aspirante ya cuenta con matricula, y una cuenta en campus donde podra acceder a su perfil como alumno. ' },
    ],
  }

  const insOrdeneslist = {
    seccion: { nombre: 'Lista de Ordenes', desc: 'Hola, las órdenes se generan desde aspirantes o en cada referencia [datos bancarios] que se envía por cada cuatrimestre' },
    guiaB: [
      {
        id: 0, icon: 'CoffeeIcon', color: 'success', titulo: 'Ver detalles', desc: 'Ver el detalle de la orden y sus aportaciones, así como el concepto de pago y el plan de pagos.', tag: 'datos',
      },
      {
        id: 1, icon: 'SlashIcon', color: 'warning', titulo: 'Cancelación', desc: 'Cancelación de la orden con su respectiva justificación.', tag: 'acción',
      },
      {
        id: 2, icon: 'KeyIcon', color: 'warning', titulo: 'Crear Cuenta Primera Vez', desc: 'Enlace para generar las credenciales por primera vez para los nuevos alumnos del campus. Es necesario realizar este paso para acceder a sus cursos en Moodle. --[ solo aparece cuando la orden de inscripción fue autorizada ]', tag: 'acción',
      },
    ],
  }
  // FOR DRIVERS
  const drvRequestSE = {
    showProgress: true,
    steps: [
      { element: '#e-filtros', popover: { title: 'Filtros', description: 'El primer paso es seleccionar el plan de estudios que desea revisar. Luego, puede utilizar los filtros adicionales disponibles para ajustar la búsqueda según sus necesidades.' } },
      { element: '#e-filtros .amg:nth-child(1)', popover: { title: 'Plan de estudios', description: 'Planes disponibles según su perfil' } },
      { element: '#e-filtros .amg:nth-child(2)', popover: { title: 'Fecha Inicio', description: 'Utilice el filtro de fechas para buscar órdenes registradas desde la misma fecha de creación del campus.' } },
      { element: '#e-filtros .amg:nth-child(3)', popover: { title: 'Cuatrimeste', description: 'Puede seleccionar según el cuatrimestre solicitado.' } },
      { element: '#e-page', popover: { title: 'Paginador', description: 'Muestra la cantidad de resultados que se visualizan en el listado.' } },
      { element: '#e-buscador', popover: { title: 'Buscador', description: 'Puede ingresar palabras clave, como "Nombre", "Referencia" o "Matrícula", según lo necesite' } },
      { element: '#e-listado', popover: { title: 'Resultados', description: 'Muestra todos los resultados encontrados según el plan de estudios seleccionado' } },
    ],
  }

  return {
    insAspiranteslist,
    insOrdeneslist,
    // DRIVERS
    drvRequestSE,
  }
}
